var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('label-slot',{attrs:{"label":_vm.label}},[_c('v-textarea',{staticClass:"description-text-field",class:{
      'readonly-class': _vm.isReadonly,
    },attrs:{"counter":"100","no-resize":"","rows":"3","outlined":"","maxLength":100,"rules":_vm.requiredRules,"placeholder":_vm.placeholder},on:{"input":_vm.sendInput}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }